/**
 * Labstep
 *
 * @module components/EntityView/SmartTable
 * @desc Component to show a smart table in prosemirror
 */

import { ProtocolConditionSmartTableCollapsibleCard } from 'labstep-web/components/ProtocolCondition/SmartTableCollapsibleCard';
import { ProtocolValueSmartTableCollapsibleCard } from 'labstep-web/components/ProtocolValue/SmartTableCollapsibleCard';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { useActiveGroup } from 'labstep-web/hooks/activeGroup';
import { EntityView } from 'labstep-web/models/entity-view.model';
import { ProtocolValue } from 'labstep-web/models/protocol-value.model';
import type React from 'react';
import type { EntityViewSmartTableProps } from './types';

export const EntityViewSmartTable: React.FC<
  EntityViewSmartTableProps
> = ({
  entityViewId,
  experimentOrProtocol,
  initialExpandedState,
}) => {
  const { activeGroup } = useActiveGroup();

  return (
    <ReadOnMountHOC
      type="entities"
      entityName={EntityView.entityName}
      params={{
        id: entityViewId,
        get_single: 1,
      }}
      loading={{ loader: 'placeholder' }}
      children={({ entity: entityView }) => {
        if (!entityView) {
          return null;
        }

        if (entityView.entity_name === ProtocolValue.entityName) {
          return (
            <ProtocolValueSmartTableCollapsibleCard
              entityView={entityView}
              experimentOrProtocol={experimentOrProtocol}
              group={activeGroup!}
              initialExpandedState={initialExpandedState}
            />
          );
        }

        return (
          <ProtocolConditionSmartTableCollapsibleCard
            entityView={entityView}
            experimentOrProtocol={experimentOrProtocol}
            group={activeGroup!}
            initialExpandedState={initialExpandedState}
          />
        );
      }}
    />
  );
};
